import { useMemo } from 'react';
import { Button, Col, Row, Space, Text } from '@/components/atoms';
import { pcompany, ptax } from '@/proto/proto';
import moment from 'moment';
import { FORMAT_DATE_SHORTEN_KR, FORMAT_DATE_SIMPLE_EXCEPT_YEAR_TIME, IMAGE_PATH_TAX_NOTICE } from '@/constants/constant';
import { Tag } from 'antd';
import Paragraph from '@/components/atoms/text/Paragraph';
import Highlighter from 'react-highlight-words';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { nameOf } from '@/components/covalent/tax/change/TaxChangeType';
import { colorOf, messageOf } from '@/components/covalent/tax/change/TaxChangeStatus';

type TaxChangeHistoryListItemProps = {
  data: ptax.IPbTaxChangeRequest;
  company: pcompany.IPbCompany;
  keyword: string;
  onClickImage?: () => void;
  onClickInformation?: () => void;
  onClickResend?: () => void;
};

const TaxChangeHistoryListItem = ({ data, company, keyword, onClickImage, onClickInformation, onClickResend }: TaxChangeHistoryListItemProps) => {
  const details = useMemo(() => {
    return data?.taxNotice?.violation?.first()?.details?.slice(0, 20);
  }, [data]);
  return (
    <Row className="list-item">
      <Col xl={2} lg={3} md={4} sm={24} xs={24} className="date" style={{ padding: '4px' }}>
        <Space direction="vertical" align="center">
          <Tag style={{ borderRadius: '20px', minWidth: '4em', textAlign: 'center', margin: 0 }} color="#999999">
            {data?.base?.id}
          </Tag>
          <Text>{moment(data.base?.createdAt).fromNow()}</Text>
        </Space>
      </Col>
      <Col xl={2} lg={3} md={4} sm={24} xs={24} className="date" style={{ padding: '4px' }}>
        <LazyLoadImage onClick={onClickImage} src={IMAGE_PATH_TAX_NOTICE(Number(company.base?.id ?? -1), data.taxNotice)} />
      </Col>
      <Col style={{ flex: 1 }} className="information">
        <Space direction="vertical">
          <Paragraph>
            <Tag>발송기관</Tag>
            <Highlighter searchWords={keyword?.split(' ') ?? []} textToHighlight={data.taxNotice?.sender ?? ''} />
          </Paragraph>
          <Paragraph>
            <Tag>차량번호</Tag>
            <Highlighter searchWords={keyword?.split(' ') ?? []} textToHighlight={data.taxNotice?.plateNo ?? ''} />
          </Paragraph>
          <Paragraph>
            <Tag>위반정보</Tag>
            {moment(data?.taxNotice?.violation?.first()?.violationAt).format(FORMAT_DATE_SHORTEN_KR)}
            {details ? ' / ' : ''}
            {details}
          </Paragraph>
        </Space>
      </Col>
      <Col xl={3} lg={3} md={3} sm={24} xs={24}>
        <Space direction="vertical" align="center">
          <Tag>{nameOf(data?.typeCode ?? -1)}</Tag>
          <Text className={colorOf(data?.statusCode ?? -1)}>{messageOf(data.statusCode ?? -1)}</Text>
          <Text>{moment(data.base?.createdAt).format(FORMAT_DATE_SIMPLE_EXCEPT_YEAR_TIME)}</Text>
        </Space>
      </Col>
      <Col xl={3} lg={3} md={3} sm={24} xs={24}>
        <Space direction="vertical" align="center">
          <Button type="default" shape="round" onClick={onClickInformation}>
            민원정보
          </Button>
          <Button type="default" shape="round" onClick={onClickResend}>
            재신청
          </Button>
        </Space>
      </Col>
    </Row>
  );
};

TaxChangeHistoryListItem.defaultProps = {
  onClickImage: undefined,
  onClickInformation: undefined,
  onClickResend: undefined,
};

export default TaxChangeHistoryListItem;
